// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9184ea59","513":"f11a0a47","703":"b3415745"}[chunkId] + ".chunk.js";
};